var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('folder-view',{attrs:{"title":_vm.title,"encryptionStr":_vm.encryptionStr,"type":_vm.type,"hasBtn":true,"hasSelect":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }